/**
 * 全站统一的一级分类(拍品品类)。
 *
 * 唯一事实来源:Browse 顶部快捷 tab、Browse 筛选面板、SessionLots 筛选抽屉
 * 全部从这里派生 —— 改这一处,三处同步,不再出现"腕表/钟表/手表""名包/箱包"
 * 名称打架、或顶部缺「美术品」的不一致。
 *
 * value 必须与后端 auction_lots.category 枚举一致:watch / jewelry / bag / art / other。
 * labelKey 走 i18n(值内含 emoji);zh 为静态兜底(用于不接 i18n 的页面,如 SessionLots)。
 */
export const LOT_CATEGORIES = [
  { value: 'watch',   labelKey: 'browse.catWatch',   zh: '⌚ 腕表' },
  { value: 'jewelry', labelKey: 'browse.catJewelry', zh: '💍 珠宝' },
  { value: 'bag',     labelKey: 'browse.catBag',     zh: '👜 名包' },
  { value: 'art',     labelKey: 'browse.catArt',     zh: '🎨 美术品' },
  { value: 'other',   labelKey: 'browse.catOther',   zh: '📦 其他' },
];

// 顶部快捷 tab 用(前置「全部」,单选)
export const LOT_CATEGORIES_WITH_ALL = [
  { value: '', labelKey: 'browse.catAll' },
  ...LOT_CATEGORIES,
];
